<button nz-button nzType="default" (click)="openAuctionListTipModal()">
  {{ 'LOT_AUCTION_TIP_ACTIONS.AUCTION_SHEETS' | translate }}
</button>
